"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Commander Spellbook API
 * API for Commander Spellbook, the combo database engine for Magic: The Gathering
 *
 * The version of the OpenAPI document: 4.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfFeatureOfCard = instanceOfFeatureOfCard;
exports.FeatureOfCardFromJSON = FeatureOfCardFromJSON;
exports.FeatureOfCardFromJSONTyped = FeatureOfCardFromJSONTyped;
exports.FeatureOfCardToJSON = FeatureOfCardToJSON;
exports.FeatureOfCardToJSONTyped = FeatureOfCardToJSONTyped;
const feature_1 = require("./feature");
/**
 * Check if a given object implements the FeatureOfCard interface.
 */
function instanceOfFeatureOfCard(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('feature' in value) || value['feature'] === undefined)
        return false;
    if (!('quantity' in value) || value['quantity'] === undefined)
        return false;
    if (!('zoneLocations' in value) || value['zoneLocations'] === undefined)
        return false;
    if (!('battlefieldCardState' in value) || value['battlefieldCardState'] === undefined)
        return false;
    if (!('exileCardState' in value) || value['exileCardState'] === undefined)
        return false;
    if (!('libraryCardState' in value) || value['libraryCardState'] === undefined)
        return false;
    if (!('graveyardCardState' in value) || value['graveyardCardState'] === undefined)
        return false;
    if (!('mustBeCommander' in value) || value['mustBeCommander'] === undefined)
        return false;
    return true;
}
function FeatureOfCardFromJSON(json) {
    return FeatureOfCardFromJSONTyped(json, false);
}
function FeatureOfCardFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'feature': (0, feature_1.FeatureFromJSON)(json['feature']),
        'quantity': json['quantity'],
        'zoneLocations': json['zoneLocations'],
        'battlefieldCardState': json['battlefieldCardState'],
        'exileCardState': json['exileCardState'],
        'libraryCardState': json['libraryCardState'],
        'graveyardCardState': json['graveyardCardState'],
        'mustBeCommander': json['mustBeCommander'],
    };
}
function FeatureOfCardToJSON(json) {
    return FeatureOfCardToJSONTyped(json, false);
}
function FeatureOfCardToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'quantity': value['quantity'],
        'battlefieldCardState': value['battlefieldCardState'],
        'exileCardState': value['exileCardState'],
        'libraryCardState': value['libraryCardState'],
        'graveyardCardState': value['graveyardCardState'],
        'mustBeCommander': value['mustBeCommander'],
    };
}
//# sourceMappingURL=featureOfCard.js.map